<template>
  <div class="container homeboxes">
    <div class="columns">
      <div class="column is-4">
        <div class="box">
          <router-link to="/projects" class="homebox">
            <h2><b>Sager</b></h2>
            <i class="fas fa-folder-open"></i>
          </router-link>
        </div>
      </div>
      <div class="column is-4">
        <div class="box">
          <router-link to="/items" class="homebox">
            <h2><b>Lager</b></h2>
            <i class="fas fa-store-alt"></i>
          </router-link>
        </div>
      </div>
      <div v-if="isAdmin" class="column is-4">
        <div class="box">
          <router-link to="/rapporter" class="homebox">
            <h2><b>Rapporter</b></h2>
            <i class="fas fa-chart-pie"></i>
          </router-link>
        </div>
      </div>
    </div>
    <div class="columns" v-if="$inventoryEnabled">
      <div class="column is-4">
        <div class="box">
          <router-link to="/customers" class="homebox">
            <h2><b>Kunder</b></h2>
            <i class="fas fa-user-tie"></i>
          </router-link>
        </div>
      </div>
      <div class="column is-4">
        <div class="box">
          <router-link to="/suppliers" class="homebox">
            <h2><b>Leverandører</b></h2>
            <i class="fas fa-truck"></i>
          </router-link>
        </div>
      </div>

      <div class="column is-4">
        <div class="box">
          <router-link to="/settings" class="homebox">
            <h2><b>Indstillinger</b></h2>
            <i class="fas fa-cogs"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["isAdmin"])
  }
};
</script>

<style lang="scss" scoped>
@import "~#/globals";

.homeboxes {
  text-align: center;
  max-width: 800px;

  @include desktop {
    margin-top: 50px;
  }
}

.homebox {
  cursor: pointer;
  color: #000;
  padding: 20px 0;

  h2 {
    margin-bottom: 10px;
  }

  .fas {
    font-size: 7rem;
    color: $primary;
  }

  &:hover {
    color: $green;

    .fas {
      color: $green;
    }
  }
}
</style>
